<template>
  <div id="app">
    <!-- <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" /> -->
    <router-view v-if="isRouterAlive" />
  </div>
</template>

<script>
export default {
  name: "App",
   provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      result: true,
      apiRoot: "",
      isRouterAlive: true
    };
  },
  created() {
    // localStorage.setItem("appid", "wx1356b9b1ef1fbe7d")
    const root = process.env.API_ROOT;
    this.apiRoot = root;
    // api.getUserMessage().then((json)=>{
    //     if(json.rt.loginstatus == false){
    //         // window.location.href='http://www.baidu.com';

    //         window.location.href= root +"/zhsathome/gologin/login?fromurl=" + encodeURIComponent(window.location.href);
    //     }
    // })
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    }
  }
};
</script>

<style>
body {
  background: #f1f1f1 !important;
}

.body-background {
  background: #fff !important;
  position: relative;
}
#app {
  font-family: "weiruanyahei", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
  font-size: 14px;
}
.page_title {
  padding: 10px;
  text-align: center;
  border-bottom: 1px solid #efefef;
  background: #fff;
  font-size: 16px;
}
.page_title .fanhui {
  float: left;
  margin-top: 2px;
}
.weui-grid__icon {
  width: 40px;
  height: 40px;
}
.weui-tabbar {
  position: fixed !important;
}
.weui-cells {
  font-size: 14px !important;
}

.weui-cell {
  line-height: 2 !important;
}

.weui-input {
  border: 0px solid #dedede !important;
  border-radius: 3px;
}

.weui-loadmore_line {
  margin-top: 10em !important;
}
button.weui-btn_plain-default,
button.weui-btn_plain-primary,
input.weui-btn_plain-default,
input.weui-btn_plain-primary {
  background: rgba(243, 213, 37,  1);
}

button.bnt-submit {
  width: 92% !important;
  background-color: #f3d525 !important;
  color: #fff;
  padding: 10px 0px;
  line-height: 15px;
  border: 1px solid #f3d525;
  margin-top: 5px;
  margin-bottom: 5px;
}

button.bnt-add {
  width: 80% !important;
  border: 1px solid #1aad19;
  color: #1aad19;
  margin-top: 5px;
  margin-bottom: 5px;
}

button.bnt-pay {
  width: 80% !important;
  border: 1px solid #177fe6;
  color: #177fe6;
  margin-top: 5px;
  margin-bottom: 5px;
}

button.bnt-pay:disabled {
  width: 80% !important;
  border: 1px solid #177fe6;
  color: #177fe6;
  margin-top: 5px;
  margin-bottom: 5px;
}
.btn-blue {
  color: #e4c822;
  padding: 3px 10px;
  border: 1px solid #e4c822;
  background: #e4c822;
  color: #ffffff;
  border-radius: 3px;
}
.btn-delete {
  color: #e4c822;
  padding: 3px 10px;
  border: 1px solid #e4c822;
  background: #e4c822;
  color: #ffffff;
  border-radius: 3px;
}
.btn-delete-button {
  color: #ffffff;
  padding: 3px 10px;
  border: 1px solid #ff0000;
  background: #ff0000;
  border-radius: 3px;
}
.btn-delete-green {
  color: #ffffff;
  padding: 3px 10px;
  border: 1px solid #1e843a;
  background: #1e843a;
  border-radius: 3px;
}

.btn-delete-button:hover {
  background: #eccee6;
}

.btn-loadmore-button {
  color: #fff;
  padding: 10px 5px;
  border: 1px solid #f3d525;
  border-radius: 3px;
  background: #f3d525;
}
.btn-loadmore-button:hover {
  background: #f3d525;
}

.search-box-fixed {
  text-align: center;
  padding: 15px 15px;
  background: #fff;
  width: 100%;
  border-bottom: 1px solid #dcdcdc;
  z-index: 999;
  display: block;
  text-align: left;
}

.content-list-box {
  margin-top: 50px;
  text-align: left;
}

.border-bottom {
  border-bottom: 1px solid #efefef;
}

.ant-btn {
  padding: 0 10px !important;
}

.content-box {
  /* border-bottom:1px dashed #8f8f8f!important; */
}

.foot-divs {
  width: 100%;
  height: 60px;
  background: #f1f1f1;
}
.wenjuan {
  text-align: left;
}
.wenjuan p {
  padding:10px 0px;
  text-align: left;
}
.wenjuan .wenjuan_cont{
  padding-left:20px;

}
</style>



// WEBPACK FOOTER //
// src/App.vue